<template>
  <FileExportDropdown :url="url" :filename="filename" class="chat-export" />
</template>

<script lang="ts">
import FileExportDropdown from '@/components/Elements/FileExportDropdown.vue'
import endpoints from '@/utils/endpoints.js'
import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * Download a customer's whole text thread as a file. Server-side, because the chat panel only ever
 * holds the pages the user has scrolled through.
 */
@Component({ components: { FileExportDropdown } })
export default class ChatExport extends Vue {
  @Prop({ type: Object, default: null }) customer

  get url(): string | null {
    if (!this.customer?.id) return null

    return endpoints.exportCustomerMessages(
      this.$route.params.merchantID,
      this.customer.id
    )
  }

  get filename(): string {
    return `texts_${this.customer?.external_id || this.customer?.id || ''}`
  }
}
</script>
